//This file contains functions for use when rendering DOM elements
//in the notes section.

import moment from 'moment';
import {sortNotes, getNotes} from './notes-functions';
import {getFilters} from './notes-filters';

//Function to show how long ago a moment in time (given as a
//timestamp) was.
const showHowLongAgo = (timestamp) => {
    return `Last Edited ${moment(timestamp).fromNow()}.`;
}

//Function to render note element in DOM. (NOT exported)
//Input: A single note to show.
//Output An <a> tag showing the note.
const generateNoteDOM = (note) => {
    //Define elements
    const noteEl = document.createElement('a');
    const titleEl = document.createElement('p')
    const statusEl = document.createElement('p')

    //Set title text as title or placeholder.
    if (note.title.trim()) {
        titleEl.textContent = note.title.trim();
    } else {
        titleEl.textContent = 'Untitled note';
    }

    //Set title formatting.
    titleEl.classList.add('list-item__title');

    //Finish creating and formatting sataus tag.
    statusEl.textContent 
        = showHowLongAgo(note.updatedAt);
    statusEl.classList.add('list-item__subtitle');

    //Constuct and format <a> element.
    noteEl.appendChild(titleEl);
    noteEl.appendChild(statusEl);
    noteEl.classList.add('list-item');

    //Set title link to edit page.
    noteEl.setAttribute('href', `./notes-edit.html#${note.id}`);

    return noteEl;
}

//Function to render the list of sorted visible notes.
const renderNotes = () => {
    //Clear old list.
    document.querySelector('#notes').innerHTML = '';

    //Get the sorted note list.
    const filter = getFilters();
    const notes = sortNotes(filter.sortBy);

    //Filter the list by the search text.
    const filteredList = notes.filter((note) => {
        if (note.title.trim()) {
            //Do filtering on note title.
            return note.title.toLowerCase().includes(
                filter.searchText.toLowerCase());
            } else {
                //Do filtering on the title the user sees.
                return new String('Untitled note').toLowerCase()
                    .includes(filter.searchText.toLowerCase());
            }
    });

    //Add new HTML elements.
    if (filteredList.length > 0) {
        filteredList.forEach((note) => {
            const noteEl = generateNoteDOM(note);
            document.querySelector('#notes').appendChild(noteEl);
        });
    } else {
        const messageEl = document.createElement('h2');
        messageEl.classList.add('empty-message');
        messageEl.textContent = 'No were notes found.';
        document.querySelector('#notes').appendChild(messageEl);    
    }
}

//Function to initialize the edit page with the note with the
//given ID. This function returns to the main page if the note
//is not found.
const initEditPage = (noteID) => {
    //Get correct note if it exists.
    const notes = getNotes(); 
    const note = notes.find(function (thisNote) {
        return thisNote.id === noteID;
    })
    
    //Go to main page if no note is found.
    if (!note) {
        location.assign('./notes-index.html');

        //Function must return to pevent error.
        return;
    }
    
    //Get page elements.
    const titleEL = document.querySelector('#note-title');
    const bodyEl = document.querySelector('#note-body');
    const lastEditedEl = document.querySelector('#last-edited');

    //If code gets here, note is valid.
    
    //Load note data.
    titleEL.value = note.title;
    bodyEl.value = note.body;
    lastEditedEl.textContent = showHowLongAgo(note.updatedAt);
}

//Export functions.
export {showHowLongAgo, renderNotes, initEditPage};